import React from 'react';
import { useTranslation } from 'react-i18next';

import Box from 'component/Incentive/Message/Box';

import i18n from 'i18next';

import { getCookieValue, setCookieValue } from 'utility/Track/cookies';

import { SortOrder } from 'types/Search/form';

const sortStepMapping: Record<number, string[]> = [];
sortStepMapping[2] = [SortOrder.TopRegion];
sortStepMapping[3] = [SortOrder.Rating, SortOrder.Popularity];
sortStepMapping[4] = [SortOrder.Price, SortOrder.Popularity];

const getTypeHint = (sortType: SortOrder) => {
    switch (sortType) {
        case SortOrder.Popularity:
            return i18n.t('TRANS-popularity-sort-based-on-customer-reviews');
        case SortOrder.Rating:
            return i18n.t('TRANS-sorting-by-guest-rating-hint');
        case SortOrder.Price:
            return i18n.t('TRANS-sorting-by-recommendation-and-price-hint');
        case SortOrder.TopRegion:
            return i18n.t('TRANS-sorting-by-regions-hint');
        default:
            return '';
    }
};

interface HintProps {
    sortType: SortOrder;
    currentStep: number;
}

const Hint = ({ sortType, currentStep }: HintProps) => {
    const { t } = useTranslation();

    if (
        sortStepMapping[currentStep]?.indexOf(sortType) > -1 &&
        !getCookieValue(`c24-travel-hideSortingHint_${sortType}`)
    ) {
        return (
            <Box
                onCloseCallback={() =>
                    setCookieValue(
                        `c24-travel-hideSortingHint_${sortType}`,
                        '1',
                        7200
                    )
                }
                data-sort={sortType}
                key={sortType} // used to reset Box state on sort change
            >
                {`${getTypeHint(sortType)} `}
                <span className="text-link-orange-hover js-transparency-initiative-more">
                    {t('TRANS-know-more')}
                </span>
            </Box>
        );
    }
    return null;
};

export default Hint;
